export default {
  allCalls: "Todas llam.",
  Unknown: "Desconocido",
  Multiple: "Múltiple"
};

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
